import React from "react";
import { useId } from "../../hooks/use-id";

/**
 * El componente DataPrivacy representa una sección de la página "Estándares Abiertos para Integraciones en EdTech" relacionada con la privacidad de datos.
 * Renderiza un iframe que muestra contenido HTML específico.
 *
 * @component
 * @example
 * // Uso del componente DataPrivacy
 * <DataPrivacy />
 *
 * @returns {JSX.Element} - El componente DataPrivacy.
 */
export const DataPrivacy = () => {
    const titleId = useId('data-privacy-iframe-title');

    return (<section aria-labelledby={titleId} className="w-100 overflow-auto">
        <h3 id={titleId} className="sr-only">
            Data Privacy Content
        </h3>
        <div className="w-100">
            <iframe
                className="w-100 onbackground-primary--bordered"
                src="/edtech/data-privacy.html"
                title="Data Privacy information for EdTech integrations"
                loading="lazy"
                style={{ minHeight: '600px', height: '80vh', border: '0' }}
            />
        </div>
        {/* Fallback accesible */}
        <p className="mt-2">
            If you can’t view the content, you can access it directly here:{" "}
            <a href="/edtech/data-privacy.html" className="focusable-red">
                View data privacy policy
            </a>
        </p>
    </section>)
} 